import { FC, useState } from 'react';

import { Button } from '@thirdspacelearning/library';

import LearningObjectivesContent from './LearningObjectivesContent';
import { LearningObjectiveForm } from './learning-objective-form';

import { PageLayout, TabsPanel } from '@shared';
import { Country, LearningObjective } from '@types';
import { countryTabList } from '@utils';

interface Props {}

const LearningObjectivesPage: FC<Props> = () => {
    const [showDialog, setShowDialog] = useState<boolean>(false);
    const [editingLearningObjective, setEditingLearningObjective] = useState<
        LearningObjective | undefined
    >();

    const [selectedTab, setSelectedTab] = useState<Country>(Country.GB);

    const onAddObjective = () => {
        setShowDialog(true);
    };

    const onEditObjective = (learningObjective: LearningObjective) => {
        setEditingLearningObjective(learningObjective);
        setShowDialog(true);
    };

    const handleDialogClose = () => {
        setShowDialog(false);
        setEditingLearningObjective(undefined);
    };

    return (
        <PageLayout
            title="TSL Learning Objectives"
            buttons={[
                <Button
                    key="addLearningObjecive"
                    onClick={onAddObjective}
                    variant="contained"
                    color="secondary"
                    data-testid="create-lo-button"
                >
                    Add a learning objective
                </Button>,
            ]}
        >
            <TabsPanel<Country>
                selectedTab={selectedTab}
                tabList={countryTabList}
                setSelectedTab={(selectedTab: Country) => {
                    setSelectedTab(selectedTab);
                }}
            />

            <LearningObjectivesContent
                onEditObjective={onEditObjective}
                country={selectedTab}
            />

            {showDialog && (
                <LearningObjectiveForm
                    learningObjective={editingLearningObjective}
                    open={showDialog}
                    onClose={handleDialogClose}
                    selectedTab={selectedTab}
                />
            )}
        </PageLayout>
    );
};

export default LearningObjectivesPage;
